<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted } from "vue";
import PasswortValidator from "@/PasswortValidator";
import { encryptForAD } from "@/ADCrypter";
import { goBack } from "@/NavigationHelper";
import CryptoJS from "crypto-js";
import { showSnackbar } from "@/UIHelper";
import { Globals } from "@/Globals";
import { globalsBezeichnung } from "@/local";
import { getSiteData, refreshFullPageContent } from "@/NavigationHelper";
const props = defineProps<{
  newTitle: string;
}>();
const emit = defineEmits(["savePW", "PWFehler"]);

let show = ref<boolean>(false);
let show1 = ref<boolean>(false);
let show2 = ref<boolean>(false);
let oldPassword = ref<string>("");
let newPassword = ref<string>("");
let rePassword = ref<string>("");
let hash = "";
let hashOld = "";

let DB: any = AUApi.Current.dB;
let Kennung: string = AUApi.Current.user.kennung;
let minLength: number = 0;
let minDigit: number = 0;
let minSpecialCharacters: number = 0;
let minUpperCase: number = 0;
let minLowerCase: number = 0;
let hintText = ref<string>("");
let userAic: any;
let userArt = ref<number>(0);
let userDatum: any;
let errorText = ref<string>("");
let siteData: any = "";
let title: string =
  siteData?.title ??
  globalsBezeichnung(Globals.Begriff, "Web_PWaendern", "Passwort ändern");
let showAlert: boolean = false;
onMounted(async () => {
  if (props.newTitle) {
    title = props.newTitle;
    siteData = getSiteData();
  }
  if (!Kennung) {
    return;
  }
  setPassword();
});
async function setPassword() {
  const response = await AUApi.Current.getUserData(DB, Kennung, "");
  if (response.data) {
    minLength = response.data.pwML;
    minDigit = response.data.pwMZ;
    minSpecialCharacters = response.data.pwMS;
    minUpperCase = response.data.pwMG; // Anzahl Großbuchstaben
    minLowerCase = response.data.pwMK;
    userAic = response.data.aic;
    userArt.value = response.data.art;
    userDatum = response.data.datum;
    if (minLength > 0) {
      hintText.value =
        globalsBezeichnung(Globals.Begriff, "Zeichen", "Mindestlänge") +
        ": " +
        minLength;
    }
    if (minDigit > 0) {
      hintText.value =
        hintText.value +
        " ," +
        globalsBezeichnung(Globals.Begriff, "Web_Ziffern", "Ziffern") +
        ": " +
        minDigit;
    }
    if (minSpecialCharacters > 0) {
      hintText.value =
        hintText.value +
        "," +
        globalsBezeichnung(
          Globals.Begriff,
          "Web_Sonderzeichen",
          "Sonderzeichen",
        ) +
        ": " +
        minSpecialCharacters;
    }
    if (minUpperCase > 0) {
      hintText.value =
        hintText.value +
        "," +
        globalsBezeichnung(
          Globals.Begriff,
          "Web_Grossbuchstaben",
          "Großbuchstaben",
        ) +
        ": " +
        +minUpperCase;
    }
    if (minLowerCase > 0) {
      hintText.value =
        hintText.value +
        "," +
        globalsBezeichnung(Globals.Begriff, " ", "Kleinbuchstaben") +
        ": " +
        +minLowerCase;
    }
  }
}
async function save() {
  if (!userArt.value) {
    showAlert = true;
    await setPassword();
  }
  let isValid: boolean = true;
  if (oldPassword.value === newPassword.value) {
    errorText.value = globalsBezeichnung(
      Globals.Begriff,
      "Passwort_gleich",
      "Passwort ident - bitte ein neues erfassen!",
    );
    emit("PWFehler", errorText.value);

    showSnackbar({
      text: errorText.value,
      duration: 4000,
      color: "red",
    });

    return;
  }

  if (newPassword.value === rePassword.value) {
    const res = PasswortValidator.validate(
      newPassword.value,
      minLength,
      minDigit,
      minSpecialCharacters,
      minUpperCase,
      minLowerCase,
    );

    isValid = res.isValid;
    errorText.value = res.message;
    if (!isValid) {
      showSnackbar({
        text: errorText.value,
        duration: 4000,
        color: "red",
      });

      return;
    } else if (userArt.value === 1) {
      const seed = newPassword.value + userAic;
      hash = CryptoJS.MD5(seed).toString();
      const seedOld = oldPassword.value + userAic;
      hashOld = CryptoJS.MD5(seedOld).toString();
    } else if (
      userArt.value === 2 ||
      userArt.value === 6 ||
      userArt.value === 7 ||
      userArt.value === 8
    ) {
      const seedConcat = userAic + "$" + newPassword.value + "#" + userDatum;

      hash = CryptoJS.MD5(seedConcat).toString();

      const seedOldConcat = userAic + "$" + oldPassword.value + "#" + userDatum;
      hashOld = CryptoJS.MD5(seedOldConcat).toString();
    }
    if (!hash || !hashOld) {
      console.warn("Hash LEER");
      return;
    }
    AUApi.Current.changePW(hash, hashOld).then((response: any) => {
      if (response) {
        const msgType = response.data.msgType;
        let info = response.data.info;
        const memo = response.data.memo;
        const title = response.data.titel;
        if (memo) {
          info = memo;
        }
        if (info) {
          errorText.value = "";
          emit("PWFehler", info);

          if (msgType === "Error") {
            showSnackbar({
              text: info,
              color: "error",
              duration: 4000,
            });
            return;
          } else if (msgType === "Info") {
            showSnackbar({
              text: info,
              color: "info",
              duration: 4000,
            });
          } else if (msgType === "Warnung") {
            showSnackbar({
              text: info,
              color: "warning",
              duration: 4000,
            });
          }

          return;
        } else {
          showSnackbar({
            text: "Passwort erfolgreich geändert!",
            color: "info",
            duration: 4000,
          });
          refresh();
          emit("savePW");
          return;
        }
      }
    });
  } else {
    errorText.value = globalsBezeichnung(
      Globals.Begriff,
      "PW_StimmtNicht",
      "Passwort stimmt nicht überein!",
    );
    emit("PWFehler", errorText.value);

    showSnackbar({
      text: errorText.value,
      duration: 4000,
      color: "red",
    });

    return;
  }
}

function refresh() {
  oldPassword.value = "";
  newPassword.value = "";
  rePassword.value = "";
}
</script>
<template>
  <form @submit.prevent>
    <v-card class="mx-auto my-5 w-100 w-sm-auto" max-width="400" :title="title">
      <v-text-field
        v-model="oldPassword"
        required
        autocomplete="current-password"
        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
        :type="show ? 'text' : 'password'"
        clearable
        density="compact"
        variant="outlined"
        :label="
          globalsBezeichnung(
            Globals.Begriff,
            'Web_Altes_Passwort',
            'altes Passwort',
          )
        "
        counter
        class="input-group--focused"
        @click:append="show = !show"
        prepend-icon="mdi-lock-outline"
      ></v-text-field>

      <v-text-field
        v-model="newPassword"
        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
        required
        autocomplete="new-password"
        :type="show1 ? 'text' : 'password'"
        clearable
        density="compact"
        variant="outlined"
        :label="
          globalsBezeichnung(
            Globals.Begriff,
            'Web_Neues_Passwort:',
            'neues Passwort',
          )
        "
        :hint="hintText"
        persistent-hint
        counter
        class="input-group--focused pt-5"
        @click:append="show1 = !show1"
        prepend-icon="mdi-lock-outline"
      ></v-text-field>

      <v-text-field
        v-model="rePassword"
        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
        :type="show2 ? 'text' : 'password'"
        required
        autocomplete="new-password"
        clearable
        density="compact"
        variant="outlined"
        :label="
          globalsBezeichnung(Globals.Begriff, 'Wiederholung_PW', 'Wiederholung')
        "
        :hint="hintText"
        persistent-hint
        counter
        class="input-group--focused pt-5"
        @click:append="show2 = !show2"
        prepend-icon="mdi-lock-outline"
      ></v-text-field>
      <v-card-actions>
        <v-spacer></v-spacer>
        <CommonBaseButtons
          :deleteVisible="false"
          :createVisible="false"
          :backVisible="true"
          :refreshVisible="false"
          :saveVisible="true"
          @save="save"
          @back="goBack()"
        ></CommonBaseButtons>
      </v-card-actions>
    </v-card>
  </form>
</template>
<style scoped>
.password {
  max-width: 300px;
}
</style>
